import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { fetchBanners } from "../store/features/productsSlice";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BannerSlider = () => {
  const dispatch = useDispatch();
  // Банери кешуються в Redux: при поверненні на головну висота сторінки та сама
  // одразу, і відновлена прокрутка не «з'їжджає»
  const banners = useSelector((state) => state.products.banners);

  useEffect(() => {
    if (banners === null) dispatch(fetchBanners());
  }, [dispatch, banners]);

  if (banners === null) {
    // Заглушка тієї ж висоти, що й банер — без стрибка сторінки
    return (
      <div className="mb-6 px-1">
        <div className="h-[180px] md:h-[220px] lg:h-[260px] rounded-2xl bg-slate-800/60 animate-pulse" />
      </div>
    );
  }

  if (!banners.length) return null;

  const settings = {
    dots: true,
    infinite: banners.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: banners.length > 1,
    autoplaySpeed: 5000,
  };

  return (
    <div className="mb-6">

      <Slider {...settings}>
        {banners.map((banner, index) => {

          const image = (
            <div
              className="
              w-full
              h-[180px]
              md:h-[220px]
              lg:h-[260px]
              overflow-hidden
              rounded-2xl
              "
            >
              <img
                src={banner.image}
                alt={banner.title}
                className="
                w-full
                h-full
                object-cover
                "
              />
            </div>
          );

          const key = banner.id != null ? banner.id : index;

          return (
            <div key={key} className="px-1">

              {banner.link ? (
                <a
                  href={banner.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {image}
                </a>
              ) : (
                image
              )}

            </div>
          );
        })}
      </Slider>

    </div>
  );
};

export default BannerSlider;